import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';
@Injectable({
  providedIn: 'root',
})
export class IntranetsService {
  private url = 'intranets';

  constructor(private httpClient: HttpClientService) {}

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  create(params: any = {}): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, params);
  }

  show(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/${params.id}.json`, params);
  }
}
